import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BroadcastService } from '../../common/services/broadcast/broadcast.service';
import { UserHttpService } from '../../user/services/user-http.service';
import { FavoriteEvents } from '../enums/favorite-events.enum';
import { GenericFavoriteService } from '../models/favorite';
import { ToastService } from '../../common/services/toast/toast.service';
import { v4 } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class FavoritePlacesService implements GenericFavoriteService<number[], number> {
  private key = 'favoritePlaces';

  public favorites$: Observable<number[]>;
  private favoriteIdsSubject: BehaviorSubject<number[]>;
  private favorites: number[];
  private serverFavorites: any[];

  constructor(
      private broadcastService: BroadcastService,
      private httpService: UserHttpService,
      private toastService: ToastService
  ) {
    this.initDefaultValues();
      this.getFavoritesData();
  }

  private initDefaultValues() {
    const defaultValue: number[] = [];
    this.favorites = defaultValue;
    this.favoriteIdsSubject = new BehaviorSubject<number[]>(null);
    this.favorites$ = this.favoriteIdsSubject.asObservable();
    this.serverFavorites = [];
  }

    private getFavoritesData() {

        this.getUserFavoritesLocations().toPromise().then(result => {
            if (result != null) {
                for (const dictkey in result) {
                    if (result.hasOwnProperty(dictkey)) {
                        let favorite = result[dictkey];
                        //store this cos it has server key
                        this.serverFavorites.push(favorite);

                        //just need jumbers
                        this.favorites.push(favorite.locationId as number);
                    }
                }

                this.notifyObserversFavoritesChanged();
            }
        }).catch(reason => {
            // ignore
        });

  }

  private notifyObserversFavoritesChanged() {
    this.favoriteIdsSubject.next([...this.favorites]);
  }

  public toggleFavorite(favorite: number): void {
      if (this.isFavorite(favorite)) {
        this.removeFavorite(favorite);
      } else {
        this.addFavorite(favorite);
      }
  }

  public isFavorite(favorite: number): boolean {
    return this.favorites.includes(favorite);
  }

  private getServerKeys(favorite: number): any[] {
      return this.serverFavorites.filter(item => item.locationId === favorite).map(item => item.id);
  }

  private removeFavorite(favorite: number) {
      const serverKeys = this.getServerKeys(favorite);
      for (let i = 0; i < serverKeys.length; i++) {
          this.deleteUserFavoritesLocation(serverKeys[i]).toPromise().then(result => {
              if (result == true) {
                  this.favorites = this.favorites.filter(locationId => locationId !== favorite as number);

                  this.notifyObserversFavoritesChanged();
                  this.broadcastService.broadcast(FavoriteEvents.UnfavoritePlace, favorite);
                  this.toastService.showSimple('Removed from favorites.');
              }
              const ind: number = this.serverFavorites.findIndex(item => item.id == serverKeys[i]);
              if (ind != -1) {
                  this.serverFavorites.splice(ind, 1);
              }
         });
      }
  }

  private addFavorite(favorite: number) {
      this.postUserFavoritesLocation({ locationId : favorite }).toPromise().then(result => {
          if (result != null) {
              this.serverFavorites.push(result);

              if (this.favorites.findIndex(item => item === result.locationId) == -1) {
                  this.favorites.push(result.locationId as number);
                  this.notifyObserversFavoritesChanged();
                  this.broadcastService.broadcast(FavoriteEvents.FavoritePlace, result.locationId);
                  this.toastService.showSimple('Added to favorites.');
              }
          }
      });
  }


    private postUserFavoritesLocation(favorite: any): Observable<any> {
        const id: string = v4();
        favorite['id'] = id;
        return this.httpService.post<any>('user/favorites/locations', favorite);
    }

    private deleteUserFavoritesLocation(id: string): Observable<boolean> {
        return this.httpService.delete<boolean>(`user/favorites/locations/${id}`);
    }

    private getUserFavoritesLocations(): Observable<any> {
        return this.httpService.get<any>('user/favorites/locations');
    }

}
